<script setup lang="ts">
import { ref } from 'vue';
import { Button, Modal, Tooltip } from 'ant-design-vue';
import { EyeOutlined } from '@ant-design/icons-vue';
import type { ButtonType } from 'ant-design-vue/es/button';

interface Props {
  title?: string;
  width?: string | number;
  size?: 'small' | 'middle' | 'large';
  type?: ButtonType;
  buttonClass?: string;
}

withDefaults(defineProps<Props>(), {
  title: 'View Details',
  width: '80%',
  size: 'middle',
  type: 'default',
  buttonClass: '',
});

const open = ref<boolean>(false);
const setVisible = (value: boolean) => {
  open.value = value;
};
</script>

<template>
  <Tooltip title="View">
    <Button
      :size="size"
      :type="type"
      :class="buttonClass"
      @click="() => setVisible(true)"
    >
      <slot name="icon">
        <EyeOutlined />
      </slot>
    </Button>
  </Tooltip>
  <Modal
    v-model:open="open"
    :title="title"
    :width="width"
    :cancel-button-props="{ ghost: true }"
    @ok="() => setVisible(false)"
  >
    <slot />
  </Modal>
</template>
